<template>
  <div class="animated fadeInRight ecommerce">
    <el-row :gutter="20">
      <el-col :span="3">
        <div class="border-radius white-bg">
          <div class="margin-xs-r treeview">
            <ul class="list-group text-center border-radius">
              <li v-for="(item, index) in auditAuthOwnerInfo.states" :key="index" @click="_swatchState(item)"
                :class="{ 'vc-node-selected': auditAuthOwnerInfo.conditions.state == item.statusCd }"
                class="list-group-item node-orgTree">
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
      </el-col>
      <el-col :span="21">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <div>{{ $t('auditAuthOwner.searchTitle') }}</div>
          </div>
          <div class="">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-input :placeholder="$t('auditAuthOwner.appUserNamePlaceholder')"
                  v-model="auditAuthOwnerInfo.conditions.appUserName" clearable />
              </el-col>
              <el-col :span="6">
                <el-input :placeholder="$t('auditAuthOwner.ownerNamePlaceholder')"
                  v-model="auditAuthOwnerInfo.conditions.ownerName" clearable />
              </el-col>
              <el-col :span="6">
                <el-input :placeholder="$t('auditAuthOwner.linkPlaceholder')" v-model="auditAuthOwnerInfo.conditions.link"
                  clearable />
              </el-col>
              <el-col :span="6">
                <el-input :placeholder="$t('auditAuthOwner.idCardPlaceholder')"
                  v-model="auditAuthOwnerInfo.conditions.idCard" clearable />
              </el-col>
            </el-row>
            <el-row :gutter="20" style="margin-top: 10px;">
              <el-col :span="6">
                <el-input :placeholder="$t('auditAuthOwner.roomNumPlaceholder')"
                  v-model="auditAuthOwnerInfo.conditions.roomName" clearable
                  @keyup.enter.native="_queryAuditAuthOwnerMethod" />
              </el-col>
              <el-col :span="6">
                <el-button type="primary" size="small" @click="_queryAuditAuthOwnerMethod">
                  {{ $t('common.search') }}
                </el-button>
                <el-button type="info" size="small" @click="_resetAuditAuthOwnerMethod">
                  {{ $t('common.reset') }}
                </el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>

        <!-- 房屋业主查询：按房屋编号查绑定房屋，核对应聘人是否为业主 -->
        <el-card class="box-card mt-20">
          <div slot="header" class="clearfix flex justify-between">
            <div>房屋业主查询</div>
            <div style="font-size: 12px; color: #909399;">输入房屋编号（支持 楼栋-单元-房号，如 1-1-101，或直接输入房号 101）</div>
          </div>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-input v-model="roomSearch.roomNum" placeholder="请输入房屋编号，如 1-1-101" clearable
                @keyup.enter.native="_searchRoomOwner" />
            </el-col>
            <el-col :span="4">
              <el-button type="primary" size="small" :loading="roomSearch.loading" @click="_searchRoomOwner">
                查询业主
              </el-button>
            </el-col>
          </el-row>
          <el-table v-if="roomSearch.searched" :data="roomSearch.rooms" border size="mini" class="mt-20">
            <el-table-column prop="roomName" label="房屋" align="center" />
            <el-table-column label="绑定业主" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.ownerName">{{ scope.row.ownerName }}</span>
                <span v-else style="color: #909399;">未绑定业主</span>
              </template>
            </el-table-column>
            <el-table-column label="业主电话" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.link">{{ scope.row.link }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="房屋状态" align="center">
              <template slot-scope="scope">
                {{ scope.row.stateName || '-' }}
              </template>
            </el-table-column>
          </el-table>
          <div v-if="roomSearch.searched && roomSearch.rooms.length === 0"
            style="text-align: center; color: #909399; padding: 10px 0;">
            未查询到该房屋编号对应的房屋
          </div>
        </el-card>

        <el-card class="box-card mt-20">
          <div slot="header" class="clearfix flex justify-between">
            <div>{{ $t('auditAuthOwner.authTitle') }}</div>
          </div>
          <div class="">
            <el-table :data="auditAuthOwnerInfo.appUsers" border style="width: 100%" v-loading="loading">
              <el-table-column prop="communityName" :label="$t('auditAuthOwner.communityName')" align="center" />
              <el-table-column :label="$t('auditAuthOwner.owner')" align="center">
                <template slot-scope="scope">
                  <div>{{ scope.row.appUserName }}</div>
                  <div v-if="scope.row.ownerId">({{ scope.row.ownerId }})</div>
                </template>
              </el-table-column>
              <el-table-column label="绑定业主" align="center" width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.ownerName">{{ scope.row.ownerName }}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="link" :label="$t('auditAuthOwner.phone')" align="center" />
              <el-table-column prop="roomName" :label="$t('auditAuthOwner.room')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.roomName || '-' }}
                </template>
              </el-table-column>
              <!-- 车牌/车位信息 -->
              <el-table-column label="车牌/车位" align="center" width="160">
                <template slot-scope="scope">
                  <div v-if="scope.row.remark">
                    <div v-if="parseRemark(scope.row.remark).carNum">
                      {{ parseRemark(scope.row.remark).carNum }}
                    </div>
                    <div v-else-if="parseRemark(scope.row.remark).psName" style="font-size:12px;color:#909399;">
                      {{ parseRemark(scope.row.remark).psName }}
                    </div>
                    <div v-else>-</div>
                  </div>
                  <div v-else>-</div>
                </template>
              </el-table-column>
              <el-table-column prop="ownerTypeCdName" :label="$t('auditAuthOwner.ownerType')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.ownerTypeCdName || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="idCard" :label="$t('auditAuthOwner.idCard')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.idCard || '-' }}
                </template>
              </el-table-column>
              <!-- 证明图片 -->
              <el-table-column label="证明图片" align="center" width="100">
                <template slot-scope="scope">
                  <div v-if="scope.row.remark && parseRemark(scope.row.remark).photoIds.length > 0">
                    <el-image
                      style="width: 40px; height: 40px; border-radius: 4px; cursor: pointer;"
                      :src="getPhotoUrl(parseRemark(scope.row.remark).photoIds[0])"
                      :preview-src-list="parseRemark(scope.row.remark).photoIds.map(id => getPhotoUrl(id))"
                      fit="cover"
                    ></el-image>
                    <span style="font-size: 12px; color: #909399;">({{ parseRemark(scope.row.remark).photoIds.length }}张)</span>
                  </div>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="stateName" :label="$t('auditAuthOwner.state')" align="center" />
              <el-table-column prop="remark" :label="$t('auditAuthOwner.remark')" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ parseRemark(scope.row.remark || '').auditRemark || parseRemark(scope.row.remark || '').text || '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="createTime" :label="$t('auditAuthOwner.createTime')" align="center" />
              <el-table-column prop="appTypeName" :label="$t('auditAuthOwner.appType')" align="center" />
              <el-table-column :label="$t('common.operation')" align="center" width="280">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.state == '10000'" size="mini" type="primary"
                    @click="_openAuditAuthOwnerModel(scope.row)">
                    {{ $t('auditAuthOwner.audit') }}
                  </el-button>
                  <el-button size="mini" type="success" @click="_openAuditAuthOwnerModel(scope.row)">
                    查看详情
                  </el-button>
                  <el-button size="mini" type="danger" @click="_deleteAppUserBindingOwnerModel(scope.row)">
                    {{ $t('common.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination class="mt-20" @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="auditAuthOwnerInfo.conditions.page" :page-sizes="[10, 20, 30, 50]"
              :page-size="auditAuthOwnerInfo.conditions.row" layout="total, sizes, prev, pager, next, jumper"
              :total="auditAuthOwnerInfo.total" />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <delete-binding-owner-dialog ref="deleteDialog" @delete-success="_deleteSuccess" />
    <reset-pwd-dialog ref="resetPwdDialog" />
  </div>
</template>

<script>
import { listAuditAppUserBindingOwners } from '@/api/owner/auditAuthOwnerApi'
import { getCommunityId } from '@/api/community/communityApi'
import { queryRooms } from '@/api/room/roomApi'
import DeleteBindingOwnerDialog from '@/components/owner/DeleteAppUserBindingOwner'
import ResetPwdDialog from '@/components/owner/ResetStaffPwd'

// 获取图片展示的基础URL
function getFileBaseUrl() {
  return window.location.origin + '/callComponent/download/getFile/file'
}

export default {
  name: 'AuditAuthOwnerList',
  components: {
    DeleteBindingOwnerDialog,
    ResetPwdDialog
  },
  data() {
    return {
      loading: false,
      roomSearch: {
        roomNum: '',
        loading: false,
        searched: false,
        rooms: []
      },
      auditAuthOwnerInfo: {
        appUsers: [],
        total: 0,
        conditions: {
          page: 1,
          row: 10,
          appUserName: '', // 申请人姓名（小程序提交的）
          ownerName: '', // 绑定业主姓名（系统登记的业主）
          idCard: '',
          link: '',
          roomName: '', // 房屋编号（模糊）
          state: '10000', // 默认选中待审核
          communityId: ''
        },
        states: [
          { name: this.$t('auditAuthOwner.all'), statusCd: '' },
          { name: this.$t('auditAuthOwner.pending'), statusCd: '10000' },
          { name: this.$t('auditAuthOwner.success'), statusCd: '12000' },
          { name: this.$t('auditAuthOwner.failed'), statusCd: '13000' }
        ]
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.auditAuthOwnerInfo.conditions.communityId = this.communityId
    this._listAuditAuthOwners()
  },
  methods: {
    // 解析 remark 字段：提取车位ID、车位描述、车牌号、图片ID、审核意见
    parseRemark(remark) {
      const result = { psId: '', psName: '', carNum: '', photoIds: [], auditRemark: '', text: '' }
      if (!remark) return result
      const parts = remark.split('；')
      const textParts = []
      parts.forEach(function(part) {
        if (part.startsWith('车位ID：')) {
          result.psId = part.replace('车位ID：', '')
        } else if (part.startsWith('车位描述：')) {
          result.psName = part.replace('车位描述：', '')
        } else if (part.startsWith('车牌号：')) {
          result.carNum = part.replace('车牌号：', '')
        } else if (part.startsWith('证明图片：')) {
          const ids = part.replace('证明图片：', '').split(',').filter(function(id) { return id })
          result.photoIds = ids
        } else if (part.startsWith('审核意见：')) {
          result.auditRemark = part.replace('审核意见：', '')
        } else {
          if (part.trim()) textParts.push(part.trim())
        }
      })
      result.text = textParts.join('；')
      return result
    },
    // 获取图片完整URL
    getPhotoUrl(fileId) {
      return getFileBaseUrl() + '?fileId=' + fileId + '&communityId=' + this.communityId + '&time=' + Date.now()
    },
    // 按房屋编号查询房屋及绑定的业主（用于审核时核对申请人是否为业主）
    async _searchRoomOwner() {
      const _roomNum = (this.roomSearch.roomNum || '').trim()
      if (!_roomNum) {
        this.$message.warning('请输入房屋编号')
        return
      }
      try {
        this.roomSearch.loading = true
        const res = await queryRooms({
          communityId: this.communityId,
          roomNum: _roomNum,
          flag: '1', // 楼栋-单元-房号 格式解析（1-1-101），非该格式则按房号查询
          page: 1,
          row: 10
        })
        this.roomSearch.rooms = res.rooms || []
        this.roomSearch.searched = true
      } catch (error) {
        console.error('查询房屋业主失败:', error)
        this.$message.error('查询房屋业主失败')
      } finally {
        this.roomSearch.loading = false
      }
    },
    async _listAuditAuthOwners() {
      try {
        this.loading = true
        const params = { ...this.auditAuthOwnerInfo.conditions }

        // 清理参数
        params.appUserName = params.appUserName.trim()
        params.ownerName = (params.ownerName || '').trim()
        params.roomName = (params.roomName || '').trim()
        params.link = params.link.trim()
        params.idCard = params.idCard.trim()

        const res = await listAuditAppUserBindingOwners(params)
        this.auditAuthOwnerInfo.appUsers = res.data
        this.auditAuthOwnerInfo.total = res.total
      } catch (error) {
        console.error('获取数据失败:', error)
        this.$message.error(this.$t('auditAuthOwner.fetchError'))
      } finally {
        this.loading = false
      }
    },
    _openAuditAuthOwnerModel(appUser) {
      this.$router.push({
        path: '/views/owner/auditAuthOwnerUndo',
        query: {
          appUserId: appUser.appUserId,
          roomId: appUser.roomId || '',
          appUserName: appUser.appUserName,
          link: appUser.link,
          idCard: appUser.idCard || '',
          remark: appUser.remark || '',
          ownerTypeCdName: appUser.ownerTypeCdName || '',
          ownerName: appUser.ownerName || '',
          state: appUser.state || ''
        }
      })
    },
    _auditSubmit(auditData) {
      console.log(auditData)
    },
    _queryAuditAuthOwnerMethod() {
      this.auditAuthOwnerInfo.conditions.page = 1
      this._listAuditAuthOwners()
    },
    _resetAuditAuthOwnerMethod() {
      this.auditAuthOwnerInfo.conditions = {
        page: 1,
        row: 10,
        appUserName: '',
        ownerName: '',
        idCard: '',
        link: '',
        roomName: '',
        state: '',
        communityId: this.communityId
      }
      this._listAuditAuthOwners()
    },
    _deleteAppUserBindingOwnerModel(row) {
      this.$refs.deleteDialog.open(row)
    },
    _resetUserPwdModel(staff) {
      this.$refs.resetPwdDialog.open(staff)
    },
    _swatchState(item) {
      this.auditAuthOwnerInfo.conditions.state = item.statusCd
      this._listAuditAuthOwners()
    },
    _deleteSuccess() {
      this._listAuditAuthOwners()
    },
    handleSizeChange(val) {
      this.auditAuthOwnerInfo.conditions.row = val
      this._listAuditAuthOwners()
    },
    handleCurrentChange(val) {
      this.auditAuthOwnerInfo.conditions.page = val
      this._listAuditAuthOwners()
    }
  }
}
</script>

<style scoped>
.animated {
  padding: 20px;
}

.border-radius {
  border-radius: 4px;
  overflow: hidden;
}

.list-group {
  padding: 0;
  margin: 0;
  list-style: none;
}

.list-group-item {
  padding: 12px 15px;
  border: 1px solid #ebeef5;
  border-bottom: none;
  cursor: pointer;
  background: #fff;
}

.list-group-item:last-child {
  border-bottom: 1px solid #ebeef5;
}

.list-group-item:hover {
  background: #ecf5ff;
}

.vc-node-selected {
  background: #409eff;
  color: white;
}

.mt-20 {
  margin-top: 20px;
}
</style>
